/** Nederlandse opsomming: ['a','b','c'] → "a, b en c". */
export function listNl(items: readonly string[]): string {
  if (items.length <= 1) return items[0] ?? ''
  return `${items.slice(0, -1).join(', ')} en ${items[items.length - 1]}`
}

/** Eerste letter hoofdletter. */
export function capitalize(text: string): string {
  return text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : text
}

/** Eerste letter klein, voor zinnen die midden in een zin landen. */
export function lowerFirst(text: string): string {
  return text ? `${text.charAt(0).toLowerCase()}${text.slice(1)}` : text
}

/** "Goedenacht" / "Goedemorgen" / "Goedemiddag" / "Goedenavond" — voor Mijn omgeving en het beheer. */
export function greeting(date = new Date()): string {
  const h = date.getHours()
  return h < 6 ? 'Goedenacht' : h < 12 ? 'Goedemorgen' : h < 18 ? 'Goedemiddag' : 'Goedenavond'
}

/** "https://www.instagram.com/beautybewust/" → "beautybewust". Geen link? Dan de salonnaam zonder spaties. */
export const instagramHandle = (url: string, salonName: string) =>
  url.replace(/^https?:\/\/(www\.)?instagram\.com\//, '').replace(/[@/?].*$|[@/]/g, '') || salonName.toLowerCase().replace(/\s+/g, '')

/** Enkelvoud of meervoud: plural(1, 'product', 'producten') → "1 product". */
export function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`
}
